"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIFullscreenTakeoverValidation = void 0;
class ChargerUIFullscreenTakeoverValidation {
    static isValid(entity) {
        // Validate entity.message for existence and correct type.
        if (entity.message == undefined)
            return false;
        if (typeof entity.message !== "string")
            return false;
        // Validate entity.expires_at for existence and correct type.
        if (entity.expires_at == undefined)
            return false;
        if (!(entity.expires_at instanceof Date))
            return false;
        return true;
    }
}
exports.ChargerUIFullscreenTakeoverValidation = ChargerUIFullscreenTakeoverValidation;
